import qs from 'qs';

const entityName = 'posm';
const serviceKey = 'POSM';

const POSM = {
    namespaced: true,

    state: {
        items: [],
        relations: [],
    },

    getters: {
        relations(state) {
            return state.relations;
        },

        items(state) {
            return state.items;
        },

        selectableItems(state) {
            return state.items.filter(i => i.isActive).sort((i1, i2) => i1.name < i2.name ? -1 : 1);
        },
    },

    mutations: {
        setItems(state, { items }) {
            state['items'] = items;
        },

        setItem(state, { item, index }) {
            state['items'][index] = item;
        },

        addItem(state, { item }) {
            state['items'].push(item);
        },

        setRelations(state, { relations }) {
            state['relations'] = relations;
        },

        setRelation(state, { relation, index }) {
            state['items'][index] = relation;
        },

        addRelation(state, { relation }) {
            state['relations'].push(relation);
        },
    },

    actions: {
        loadItems({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => (
                    commit('setItems', {
                        items: response.data
                    }),  
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', `Список '${entityName}' получен`),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', `Ошибка при получении списка '${entityName}'`),
                    reject(err);
                });
            })
        },

        loadRelations({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service[serviceKeyRelations],
                    }),
                }).then(response => (
                    commit('setItems', {
                        items: response.data
                    }),  
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', `Список '${entityName}' получен`),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', `Ошибка при получении списка '${entityName}'`),
                    reject(err);
                });
            })
        },

        save({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': JSON.stringify(data.data),
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные успешно отредактированы');
                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;

                        commit('addItem', {
                            item: data.data,
                        });
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Запись создана');
                    }
                    resolve(response);
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных');
                        reject(err);
                });
            })
        },

        remove({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': JSON.stringify(data.item),
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => (
                    dispatch('loadItems'),
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Запись удалена'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении записи'),
                    reject(err);
                });
            })
        },
    },
};

export default POSM;


// WEBPACK FOOTER //
// ./src/store/modules/posm.js